import { render, staticRenderFns } from "./KeyCompanies.vue?vue&type=template&id=06ac059e&"
import script from "./KeyCompanies.vue?vue&type=script&lang=js&"
export * from "./KeyCompanies.vue?vue&type=script&lang=js&"
import style0 from "./KeyCompanies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports